import { TableHead, TableRow, TableCell, Checkbox, IconButton, Box, TextField } from "@mui/material";
import { grey } from "@mui/material/colors";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { ArrowDownwardRounded, ArrowUpwardRounded, CancelRounded } from "@mui/icons-material";

const defCellpadding = 1;

const TanstackDatagridHead = ({
	table,
	headerHeight,
	headerRowStyle,
	checkboxSelection,
	allowColumnResize,
	disableColumnFilter = false,
	disableColumnSort = false,
	columnFilters,
	setColumnFilters,
	buildRenderContext,
}) => {
	const showFilter = !disableColumnFilter;
	const showSort = !disableColumnSort;
	const hasHeaderActions = showFilter || showSort;

	return (
		<TableHead>
			{table.getHeaderGroups().map((hg) => (
				<TableRow key={hg.id} sx={{ position: "sticky", top: 0, zIndex: 3, ...headerRowStyle, height: headerHeight }}>
					{checkboxSelection && (
						<TableCell padding="checkbox" sx={{ width: 48, height: headerHeight }}>
							<Checkbox
								checked={table.getIsAllRowsSelected()}
								indeterminate={table.getIsSomeRowsSelected()}
								onClick={(e) => e.stopPropagation()}
								onChange={table.getToggleAllRowsSelectedHandler()}
							/>
						</TableCell>
					)}
					{hg.headers.map((header) => {
						const colId = header.column.id;
						const isFiltering = showFilter && columnFilters[colId] !== undefined;

						const sortBtn = showSort ? (
							<IconButton
								className="header-actions"
								size="small"
								onClick={header.column.getToggleSortingHandler()}
								sx={{ opacity: header.column.getIsSorted() ? 1 : 0.6, color: grey[900] }}>
								{header.column.getIsSorted() === "asc" ? (
									<ArrowUpwardRounded fontSize="inherit" />
								) : (
									<ArrowDownwardRounded fontSize="inherit" />
								)}
							</IconButton>
						) : null;

						const filterBtn = showFilter ? (
							<IconButton
								className="header-actions"
								size="small"
								sx={{ opacity: isFiltering ? 1 : 0.6, color: grey[900] }}
								onClick={() => setColumnFilters((p) => ({ ...p, [colId]: p[colId] === undefined ? "" : undefined }))}>
								{isFiltering ? <CancelRounded fontSize="inherit" /> : <FilterAltIcon fontSize="inherit" />}
							</IconButton>
						) : null;

						const actionBtns = hasHeaderActions ? (
							<>
								{filterBtn}
								{sortBtn}
							</>
						) : null;

						return (
							<TableCell
								key={header.id}
								style={{ width: `${header.getSize()}px` }}
								sx={{ boxSizing: "border-box", height: headerHeight, padding: 0, position: "relative" }}>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										width: "100%",
										height: "100%",
										...(hasHeaderActions
											? {
													"& .header-actions": {
														display: isFiltering ? "inline-flex" : "none",
														opacity: isFiltering ? 1 : 0,
														transition: "opacity 0.15s ease-in-out",
													},
													"&:hover .header-actions": { display: "inline-flex", opacity: 1 },
												}
											: {}),
									}}>
									{isFiltering ? (
										<Box sx={{ flex: 1, minWidth: 0, height: "100%", display: "flex", alignItems: "center", p: defCellpadding, boxSizing: "border-box", boxShadow: `inset 5px 5px 10px ${grey[300]}`, backgroundColor: grey[100] }}>
											<TextField
												variant="standard"
												autoFocus
												placeholder={`Filter ${header.column.columnDef.header}`}
												value={columnFilters[colId] || ""}
												onChange={(e) => setColumnFilters((p) => ({ ...p, [colId]: e.target.value || undefined }))}
												fullWidth
											/>
											{actionBtns}
										</Box>
									) : (
										header.column.columnDef.meta.renderHeader({
											...buildRenderContext({ value: header.column.columnDef.header, row: null, rowModel: null, column: header.column.columnDef, cell: null, header, table }),
											headerText: header.column.columnDef.header,
											children: actionBtns,
										})
									)}
								</Box>
								{allowColumnResize && (
									<div
										onMouseDown={header.getResizeHandler()}
										onTouchStart={header.getResizeHandler()}
										style={{ position: "absolute", right: 0, top: 0, height: "100%", width: "5px", cursor: "col-resize", userSelect: "none", touchAction: "none", zIndex: 10, backgroundColor: header.column.getIsResizing() ? grey[600] : "transparent" }}
										onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = grey[400]; }}
										onMouseLeave={(e) => { if (!header.column.getIsResizing()) e.currentTarget.style.backgroundColor = "transparent"; }}
									/>
								)}
							</TableCell>
						);
					})}
				</TableRow>
			))}
		</TableHead>
	);
};

export default TanstackDatagridHead;
